import i18n from 'services/base/i18n';

export default {
  // Text for the link to the edit pangolin information page
  edit: () => i18n.pgettext('Pages|View Pangolin', 'Edit Pangolin info'),

  // Text for the link to the device information page
  deviceInformation: () => i18n.pgettext('Pages|View Pangolin', 'Device Information'),

  // Text for the link to the Traffic History page
  trafficHistory: () => i18n.pgettext('Pages|View Pangolin', 'Traffic History'),

  // Text for the link to the Bandwidth Prioritization page
  bandwidthPrioritization: () => i18n.pgettext('Pages|View Pangolin', 'Bandwidth Controls'),

  // Text for the link to the Parental Controls page
  parentalControls: () => i18n.pgettext('Pages|View Pangolin', 'Parental Controls'),

  // Text for the link to the VPN Server page
  vpnServer: () => i18n.pgettext('Pages|View Pangolin', 'VPN Server'),

  // Text for the link to the intercept tuning settings page
  interceptTuning: () => i18n.pgettext('Pages|View Pangolin', 'Intercept Tuning'),

  // Text for the link to the scanner tuning settings page
  scannerTuning: () => i18n.pgettext('Pages|View Pangolin', 'Scanner Tuning'),

  // Text for the link to the super user settings page
  superUser: () => i18n.pgettext('Pages|View Pangolin', 'Super User Settings'),
};
